import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const UniversityBuildingIcon = createIcon({
  displayName: 'UniversityBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21 21v-16 0c0-.552285-.447715-1-1-1h-16l-4.37114e-08 8.88178e-16c-.552285 2.41411e-08-1 .447715-1 1 0 0 0 0 0 0v16"
        ></path>
        <polyline
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          points="13.5,21 13.5,18 10.5,18 10.5,21"
        ></polyline>
        <line
          x1="10"
          x2="14"
          y1="18"
          y2="18"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="2"
          x2="22"
          y1="21"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 10.875l-2.2715e-09-7.4607e-14c-.0684833-2.22574e-06-.124002.0555127-.124004.123996 -1.08773e-08.000334682 1.33323e-06.000669362 4.03228e-06.00100403l1.77636e-15 1.88745e-08c1.04241e-08.0690356.0559644.125.125.125 .0690356-1.04241e-08.125-.0559644.125-.125l4.64126e-09 2.95266e-07c-.00108406-.0689705-.0570228-.124465-.126-.125"
        ></path>
        <line
          x1="10"
          x2="14"
          y1="14"
          y2="14"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21 10h-4.076l-4.486-2.691 7.83519e-08 4.70117e-08c-.316684-.190013-.712315-.190013-1.029-9.40233e-08l-4.485 2.691h-3.924"
        ></path>
        <line
          x1="6.92"
          x2="6.92"
          y1="10"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="16.92"
          x2="16.92"
          y1="21"
          y2="10"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <rect width="24" height="24"></rect>
      </g>
    </>
  ),
})

const UniversityBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={UniversityBuildingIcon} {...props} />
}

export default memo(UniversityBuilding)
